import { useEffect, useState } from "react";
import { RefreshCw, Quote } from "lucide-react";
import api from "@/lib/api";

/**
 * Rotating daily motivational quote — INLINE content only.
 * iter111 · The outer card/frame and quote icon are now owned by the caller
 * (see `QuoteBox` in PatientHome). Rendering them here caused a duplicate
 * card + duplicate icon on the Today header. This component only emits the
 * quote text, attribution and the shuffle button.
 */
export default function DailyQuote() {
  const [q, setQ] = useState(null);
  const [loading, setLoading] = useState(true);
  const [shuffling, setShuffling] = useState(false);

  const load = async (refresh = false) => {
    if (refresh) setShuffling(true); else setLoading(true);
    try {
      const { data } = await api.get(`/quote/today${refresh ? "?refresh=true" : ""}`);
      setQ(data);
    } catch { /* silent */ }
    setLoading(false); setShuffling(false);
  };
  useEffect(() => { load(false); }, []);

  return (
    <div className="flex items-start gap-3" data-testid="daily-quote">
      <Quote size={18} className="text-[color:var(--fl-orange)] shrink-0 mt-1 opacity-70" />
      <div className="flex-1 min-w-0">
        {loading ? (
          <div className="text-sm" style={{ color: "var(--fl-muted)" }}>Loading today's quote…</div>
        ) : q ? (
          <>
            <p className="text-base md:text-lg leading-snug" style={{ color: "var(--fl-text)" }}>
              "{q.text}"
            </p>
            <div className="fl-label mt-2 text-[color:var(--fl-orange)]">— {q.author}</div>
          </>
        ) : null}
      </div>
      <button
        onClick={() => load(true)}
        disabled={shuffling}
        className="fl-btn-ghost text-xs shrink-0 disabled:opacity-40"
        title="Shuffle another quote"
        data-testid="quote-shuffle-btn"
      >
        <RefreshCw size={12} className={shuffling ? "animate-spin" : ""} />
      </button>
    </div>
  );
}
